




























































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, AuthorizePatientPaymentRequest } from '@/types/request';
import { MathUtils } from '@/util/mathUtils';

declare global {
    interface Window { Stripe: any; }
}

@Component({
    mixins: [validationMixin],
    validations: {
        cardHolderName: {
            required,
            regex: (value: string) => /^[a-zA-Z0-9 ]+$/.test(value),
        },
    },
})
export default class PatientPaymentModal extends Vue {
    private requestId: string = '';
    private serviceType: string = '';
    private appointmentDateTime: string = '';
    private cardHolderName: string = '';
    private patientName: string = '';
    private isCardValid: boolean = false;
    private cardTouched: boolean = false;
    private paymentSuccess: boolean = false;
    private creditCard: any = {};
    private totalAmountInUSD = '';
    private amount = 0;
    private patientId = '';
    private isLinkValid = true;
    private paymentCustomer = '';
    private errorMessage = '';

    get isPayButtonDisabled(): boolean {
        return !this.cardHolderName || !this.isCardValid
            || !this.$v.cardHolderName.$dirty || this.$v.cardHolderName.$invalid;
    }

    public mounted() {
        const stripe = window.Stripe(this.$store.state.stripePublicKey);
        const elements = stripe.elements();
        const style = {
            base: {
                'color': '#32325d',
                'fontFamily': '"verdana"',
                'fontSmoothing': 'antialiased',
                'fontSize': '16px',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a',
            },
        };
        const card = elements.create('card', { style });
        card.mount('#card-element');
        card.on('focus', () => {
            this.cardTouched = true;
        });
        card.on('change', async (event: any) => {
            this.creditCard.cardToken = undefined;
            if (event.complete) {
                const token = await stripe.createToken(card);
                this.isCardValid = true;
                this.creditCard.cardToken = token;
            } else if (event.error) {
                this.isCardValid = false;
            }
            this.$emit(MedTransGoConstants.EVENT_CHANGE, this.creditCard);
        });
        this.getRequestDetails();
    }

    private setCardHolderName() {
        if (!this.$v.cardHolderName.$invalid) {
            this.creditCard.cardHolderName = this.cardHolderName;
        } else {
            this.creditCard.cardHolderName = '';
        }
        this.$emit(MedTransGoConstants.EVENT_CHANGE, this.creditCard);
    }

    private async authorizePayment() {
        try {
            const iHttpService = ObjectFactory.getHttpService();
            const request: AuthorizePatientPaymentRequest = {
                paymentSource: this.creditCard.cardToken.token.id,
                requestId: this.$route.params.id,
                amount: this.amount,
                customerid: this.paymentCustomer,
            };
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/patientPay/authorize/${this.$route.params.id}`,
                loaderEvent: {
                    show: true,
                },
                data: request,
            };
            const response = await iHttpService.post<any>(apiRequest);
            if (response.success && response.statusCode === 200) {
                this.paymentSuccess = true;
            } else {
                this.errorMessage = response.errorCode as any;
            }
        } catch (error) {
            this.errorMessage = (error as { errorCode: string }).errorCode;
        }
    }

    private async getRequestDetails() {
        const iHttpService = ObjectFactory.getHttpService();
        try {
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_REQUEST}/patientPay/requestDetails/${this.$route.params.id}`,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.get<any>(apiRequest);
            if (response.success && response.data) {
                this.amount = response.data.amount;
                this.totalAmountInUSD = MathUtils.formatCurrency(response.data.amount);
                this.patientName = response.data.patientName;
                this.appointmentDateTime = response.data.appointmentTime;
                this.serviceType = response.data.requestType;
                this.requestId = response.data.requestId;
                this.paymentCustomer = response.data.customerId;
            } else {
                this.isLinkValid = false;
            }
        } catch (error) {
            this.errorMessage = error as string;
            this.isLinkValid = false;
        }
    }

    private redirectToMTGWebsite() {
        location.href = 'https://medtransgo.com';
    }

}
